import { RIGHT_SIDEBAR_MAX_WIDTH_VW, RIGHT_SIDEBAR_WIDTH } from "@/constants/ai-chat";

/** CSS width of the Darwin panel: never narrower than the default, never wider than 40% of the window. */
export const toRightSidebarCssWidth = (widthPx: number | null): string =>
    widthPx === null
        ? RIGHT_SIDEBAR_WIDTH
        : `clamp(${RIGHT_SIDEBAR_WIDTH}, ${widthPx}px, ${RIGHT_SIDEBAR_MAX_WIDTH_VW}vw)`;

const getRootFontSizePx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

/** Same limits as the CSS clamp, in px, so the stored width stays meaningful. */
export const clampRightSidebarWidthPx = (widthPx: number): number => {
    const minPx = parseFloat(RIGHT_SIDEBAR_WIDTH) * getRootFontSizePx();
    const maxPx = Math.max(minPx, (window.innerWidth * RIGHT_SIDEBAR_MAX_WIDTH_VW) / 100);
    return Math.round(Math.min(Math.max(widthPx, minPx), maxPx));
};
